import env from "@/env";

export default {
  NOMBRE_SISTEMA: env("VUE_APP_NOMBRE_SISTEMA"),
  NOMBRE_CLIENTE: env("VUE_APP_NOMBRE_CLIENTE"),
  AREA_CLIENTE: env("VUE_APP_AREA_CLIENTE"),
  SIGLA_CLIENTE: env("VUE_APP_SIGLA_CLIENTE"),
  NOMBRE_UBIGEO: env("VUE_APP_NOMBRE_UBIGEO"),
  NOMBRE_DEPARTAMENTO: env("VUE_APP_NOMBRE_DEPARTAMENTO"),
  NOMBRE_PROVINCIA: env("VUE_APP_NOMBRE_PROVINCIA"),
  NOMBRE_CENTROPOBLADO: env("VUE_APP_NOMBRE_CENTROPOBLADO"),
  CODIGO_DEPARTAMENTO: env("VUE_APP_CODIGO_DEPARTAMENTO"),
  CODIGO_PROVINCIA: env("VUE_APP_CODIGO_PROVINCIA"),
  CODIGO_CENTROPOBLADO: env("VUE_APP_CODIGO_CENTROPOBLADO"),
  UBIGEO: env("VUE_APP_UBIGEO"),
  COLOR_PRIMARY: env("VUE_APP_COLOR_PRIMARY")
};
